import { Button } from '@components/Button/';
import Block from '@components/Layout/Block';
import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import RichText from '@components/RichText';
import { Document } from '@contentful/rich-text-types';

import { observer } from 'mobx-react-lite';
import { useStores } from 'mobx/useStores';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import {
  AdvisorWrapper,
  Container,
  ContentContainer,
  Eyebrow,
  Header,
  ImageWrapper,
  Text,
} from './styles';

export interface AdvisorPromoProps {
  advisorPromoHeader?: string;
  advisorPromoBody?: string;
  customAdvisors?: any;
  advisorsCustom?: any;
}

// **Same as BlogHomepageFeaturedArticles but with different styled header and a CTA
const AdvisorPromo: FC<AdvisorPromoProps> = observer(
  ({ advisorPromoBody, advisorPromoHeader, advisorsCustom, customAdvisors }) => {
    const t = useTranslations();
    const { shopStore } = useStores();
    const { shopPathPrefix } = shopStore;

    const selectedCustomAdvisors = advisorsCustom ?? customAdvisors;

    const mappedAdvisorsCustom = selectedCustomAdvisors?.map((advisor) => {
      return {
        key: advisor?.sys?.id,
        alt_text: advisor?.fields?.title,
        img: advisor?.fields?.img?.fields?.file?.url,
      };
    });

    const header = advisorPromoHeader ? advisorPromoHeader : t('AdvisorPromo.header');
    const bodyText = advisorPromoBody ? advisorPromoBody : t('AdvisorPromo.body');

    // check if the mappedAdvisorsCustom has any items in it and they are not empty objects, then add it to mappedAdvisorsTotal
    const people =
      mappedAdvisorsCustom &&
      mappedAdvisorsCustom?.length > 0 &&
      mappedAdvisorsCustom?.every((obj) => Object.keys(obj).length !== 0)
        ? mappedAdvisorsCustom
        : [];

    return (
      people.length > 0 && (
        <Block>
          <Container>
            {header && <Header data-testid="advisor-promo-header">{header}</Header>}
            <VerticalLineSeparator />
            <AdvisorWrapper $gridSize={people && people.length <= 2 ? people.length : undefined}>
              {people &&
                people.map((person, i) => (
                  <ImageWrapper data-testid={`advisor-${i}`} key={person.key ? person.key : i}>
                    <AdvisorHeadshot img={person.img} alt_text={person.name} />
                  </ImageWrapper>
                ))}
            </AdvisorWrapper>
            <Eyebrow data-testid="advisor-promo-eyebrow">{t('AdvisorPromo.eyebrow')}</Eyebrow>
            <ContentContainer>
              {bodyText && (
                <Text>
                  {typeof bodyText === 'object' ? (
                    <RichText richText={bodyText as Document} />
                  ) : (
                    bodyText
                  )}
                </Text>
              )}
              <Button
                dataTestId="meet-our-team-btn"
                arrow={true}
                variant={'tertiaryBlack'}
                url={`${shopPathPrefix}/our-advisors`}
                label={t('AdvisorPromo.cta')}
              />
            </ContentContainer>
          </Container>
        </Block>
      )
    );
  },
);

export default AdvisorPromo;
